<template>
    <div>
        <app-reviewform v-if="review"
        v-bind:parentObject="{
            review: this.review,
        }"
        />
    </div>
</template>

<script>

import reviewForm from '../../sscomponents/performance/ReviewForm.vue';

export default {

    components: {
        'app-reviewform': reviewForm,
    },

    data() {
        return {
            review: this.$route.params.review,
        }

        
    },

    methods: {
        
    },

    mounted() {
        console.log("Review:", this.review);
    }
}

</script>

<style scoped>

</style>